export default function create(options) {
  const easing = 'sineOut';
  return [{
    ...options,
    easing,
    part: 'BG_MEDIA',
    startOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'contain',
      offset: {
        type: 'percentage',
        value: 100
      }
    },
    keyframes: [{
      transform: 'rotate(22deg)'
    }, {
      transform: 'rotate(0deg)'
    }]
  }];
}
//# sourceMappingURL=BgRotate.js.map